// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf, arrayOf, recordOf, maybe } from "@altostra/type-validations";
import { string, nullValidation, number } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdCustomRolesCustomRoleManagementDataResult = objectOf({
  custom_roles: arrayOf(
    objectOf({
      id: string,
      name: string,
      permissions: arrayOf(
        objectOf({
          company_id: string,
          app_group_id: string,
          territory_id: anyOf(string, nullValidation),
          scope_id: string,
          scope: number,
          name: number,
        })
      ),
      permission_set_assignments: arrayOf(
        objectOf({
          agps_id: string,
          ag_id: string,
        })
      ),
      number_of_assignee_developers: number,
      number_of_app_groups: number,
      number_of_territories: number,
      last_updated_at: string,
      scim_groups: maybe(arrayOf(string)),
    })
  ),
  permission_sets: arrayOf(
    objectOf({
      id: string,
      name: string,
      permissions: arrayOf(number),
      number_of_assignee_developers: number,
    })
  ),
  app_groups: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
  teams: recordOf(
    arrayOf(
      objectOf({
        id: string,
        name: string,
        ag_id: string,
      })
    )
  ),
  scim_groups: maybe(
    recordOf(
      objectOf({
        id: string,
        eid: string,
        ex_id: anyOf(string, nullValidation),
        name: string,
        developer_ids: arrayOf(string),
      })
    )
  ),
});
